import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '@app/components/dialog/dialog.service';
import { DeviceService, EventTrackerService, LogService } from '@app/core';
import { AppParametersService } from '@app/core/token/app-parameters.service';
import { IndicatorService } from '@app/shared';
import { iNotification, NotificationService } from '@app/shared/notification/notification.service';
import { environment } from '@env/environment';

import { DialogWishlistItemComponent } from './dialog-wishlist-item/dialog-wishlist-item.component';
import { Wishlist } from './iwishlist';
import { WishlistService } from './wishlist.service';

@Component({
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.scss']
})

export class WishlistComponent implements OnInit {
  public appVersionNotSupport: boolean = false;
  private categoryNameText: string = '';
  private wishlistItems: Array<Wishlist>;
  public wishlistFilteredItems = {};
  public isShowBtnBuy: boolean = false;
  public _environment = environment;
  public _showTab = [true, false, false, false];
  public searchText: string = '';
  public dataBadge: object = [];
  public maxRatingCount = [1, 2, 3, 4, 5];
  private appVersion: string;

  constructor(
    private readonly parametersService: AppParametersService,
    private readonly dialog: DialogService,
    private readonly notification: NotificationService,
    private readonly wishlistService: WishlistService,
    public readonly device: DeviceService,
    private readonly indicator: IndicatorService,

    private readonly router: Router,
    private readonly log: LogService,

    private readonly eventTracker: EventTrackerService) {
    this.isShowBtnBuy = this.device.isCaffebazar();
  }

  public onShowNotification(e: iNotification) {
    this.notification.setNotification(e);
  }


  public ngOnInit() {
    this.getWishlistItems();
    if (this.device.isAndroid()) {
      const version = this.device.getAppVersion();
      this.appVersion = version.split(' ')[0];
      this.log.logger('app version' + this.appVersion);
      if (this.appVersion < '3.0.7')
        this.appVersionNotSupport = true;
    }
  }

  public getWishlistItems() {
    this.wishlistService.getWishlistItems()
      .subscribe((results: any) => {
        this.log.logger(results);
        this.wishlistItems = results.items;
        this.filterChange(this.searchText);
        this.indicator.hide();
        this.indicator.hideHude();
      });
  }
  public showTab(index) {
    this._showTab = this._showTab.map(c => false);
    this._showTab[index] = true;
  }
  public gotoLibrary(productId, event, audiobookTitle) {
    event.stopPropagation();
    this.eventTracker.logEvent('x_direct_purchace', { location_screen: 'wishlist', x_title: audiobookTitle });
    this.device.purchaseBook(productId);
    this.indicator.hide();
  }

  public goToBook(id) {
    this.indicator.show();
    this.router.navigate(['/audiobook', id]);
  }

  public openOptionDialog(productId, event, title): void {
    event.stopPropagation();
    let dialogRef = this.dialog.open(DialogWishlistItemComponent, {
      data: {
        productId,
        title
      }
    });
    dialogRef.afterClosed.subscribe(res => {
      if (res?.remove) {
        this.removeItem(res.productId);
        return;
      }
    });
  }

  private removeItem(productId) {
    this.log.logger('delete item = ' + productId);
    this.indicator.showHude();
    this.wishlistService.removeItem({ productId })
      .subscribe((results: any) => {
        this.log.logger('removed item from db');
        this.log.logger(results);
        this.onShowNotification({ text: 'از نشان شده‌ها حذف شد', type: 'info' });
        this.getWishlistItems();
      }, err => {
        this.indicator.hideHude();
        if (err.error && err.error.message)
          this.onShowNotification({ text: err.error.message, type: 'error' });
        else
          this.onShowNotification({ text: 'در حذف آیتم نشان شده‌ خطایی رخ داد. لطفا دوباره تلاش کنید', type: 'error' });
      });
  }

  public filterItems(searchText: string, contentType: number) {
    this.searchText = searchText;
    return this.wishlistItems.filter(it => {
      let res;
      if (searchText) {
        res = it.product["audioBook"].title.toLowerCase().includes(searchText) && it.product["audioBook"].contentType == contentType;
      } else {
        res = it.product["audioBook"].contentType == contentType;
      }
      return res;
    });
  }

  public filterChange(searchText: string) {
    for (let i = 0; i <= 3; i++) {
      this.log.logger(i);
      this.wishlistFilteredItems[i] = this.filterItems(searchText, i);
      this.dataBadge[i] = this.wishlistFilteredItems[i].length;
    }
    this.log.logger(this.wishlistFilteredItems);
  }
}
